/*=========================================
  RESEARCH GALLERY
  Scroll Reveal Animation
=========================================*/

document.addEventListener("DOMContentLoaded", function () {

    const items = document.querySelectorAll(".gallery-item");

    if (!items.length) return;

    const observer = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

            if (entry.isIntersecting) {

                items.forEach((item, index) => {

                    setTimeout(() => {

                        item.classList.add("show");

                    }, index * 150);

                });

                observer.disconnect();

            }

        });

    }, {
        threshold: 0.2
    });

    observer.observe(items[0]);

});